var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"title":"Gasverbrauch Analysieren","breadcrumbs":_vm.breadcrumbs,"pageInfo":_vm.pageInfo,"loading":false}},[_c('GasConsumptionWrapper',{attrs:{"settings":_vm.settings,"showUpload":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }